var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdpBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 4,
    fill: "url(#paint0_radial_10512_2103)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46085 8.12102C2.07032 8.51154 2.07032 9.14471 2.46085 9.53524C2.85137 9.92576 3.48453 9.92576 3.87505 9.53524M2.46085 8.12102C2.85137 7.73049 3.48453 7.73049 3.87505 8.12102C4.26558 8.51154 4.26558 9.14471 3.87505 9.53524M2.46085 8.12102C1.6798 7.33997 1.67968 6.07362 2.46072 5.29257L5.28914 2.46413C6.07018 1.68308 7.33654 1.68323 8.11758 2.46428M3.87505 9.53524C4.6561 10.3163 5.92226 10.3164 6.7033 9.53539L9.53172 6.70695C10.3128 5.9259 10.3128 4.65955 9.53179 3.8785M8.11758 2.46428C7.72706 2.85481 7.72706 3.48797 8.11758 3.8785C8.50811 4.26903 9.14127 4.26903 9.53179 3.8785M8.11758 2.46428C8.50811 2.07375 9.14127 2.07375 9.53179 2.46428C9.92231 2.85481 9.92231 3.48797 9.53179 3.8785M6.74622 5.24976L5.24622 6.74976",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10512_2103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.60908 10.6909) rotate(-45) scale(12.9979 188.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdpBadge);
export default __webpack_public_path__ + "static/media/CdpBadge.87aa4c618dbb948f2c851d1476d8ee2a.svg";
export { ForwardRef as ReactComponent };